(function () {
  "use strict";

  function init() {
    var cards = document.querySelectorAll(".service-cards .card");
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (e.target.closest(".card__cta--link")) return;
        card.classList.toggle("is-expanded");
      });

      card.addEventListener("mouseleave", function () {
        card.classList.remove("is-expanded");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
